import Vue from "vue";
import Router from "vue-router";
import store from "@/store"
import {toggleBusy} from "@/util/ComponentUtils";

Vue.use(Router);

const index = new Router({
    // mode: "history",
    base: process.env.BASE_URL,

    routes: [
        {
            path: "/",
            name: "Auth",
            redirect: "/auth/login",
            component: () => import("@/layouts/full-layout/FullLayout"),
            meta: {
                requiresAuth: false,
            },
            children: [
                {
                    name: "Main",
                    path: "/main",
                    component: () =>
                        import("@/views/Main"),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "/prob_katalogou",
                    component: () => import("@/views/katalogoiYpoxreon/ViewCatalog"),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "/manage_catalogs",
                    component: () => import("@/views/katalogoiYpoxreon/CatalogManagement"),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "/limits",
                    component: () => import("@/views/katalogoiYpoxreon/TimeLimits"),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "/limit_exceptions",
                    component: () => import("@/views/foreis/ManageLimitExceptions"),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    name: "FinInstitutions",
                    path: "/manage_institutions",
                    component: () =>
                        import("@/views/institutions/FinInstitutions.vue"),
                    meta: {
                        requiresAuth: true,
                    },
                },

            ],
        },
        {
            path: "/auth/login",
            component: () => import("@/views/authentication/FullLogin"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/auth/login",
            component: () => import("@/layouts/blank-layout/Blanklayout"),
            children: [
                {
                    name: "Login",
                    path: "login",
                    component: () => import("@/views/authentication/FullLogin"),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    name: "Error",
                    path: "error",
                    component: () => import("@/views/authentication/Error"),
                },
            ],
        },
        {
            path: "/auth/logout",
            name: "logout",
            component: () => import("@/views/authentication/FullLogin"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "*",
            component: () => import("@/views/authentication/Error"),
        },
    ],
});

index.beforeResolve(async (to, from, next) => {
    try {
        if (to.name !== 'Auth') {
            await toggleBusy(true)
        }
        if (to.path) {
            // Start the route progress bar.
            // NProgress.start(800);
            if (to.matched.some(route => route.meta.requiresAuth)) {
                if (store.getters['auth/isAuthenticated']) {
                    if (to.path != '/main') {
                        if (store.getters['auth/getProfile'].menuT052.some(row => '/' + row.program == to.path)) {
                            next();
                        } else {
                            next({path: from.path})
                        }
                    }
                } else {
                    next({path: '/'});
                }
            }

        }
        next();
    } catch (e) {
        next({path: '/'});
        console.log(e)
        await toggleBusy(false)
    }
    return false
})

index.afterEach(async () => {
    // Complete the animation of the route progress bar.
    // toggleBusy(false)
    await toggleBusy(false)
});

export default index;
